import { Injectable, inject } from '@angular/core';
import { FormlyAttachmentDownloader } from '@intalio/formly-builder';
import { AttachmentHelperService } from '../services/attachment-helper.service';

@Injectable()
export class AvsecAttachmentDownloaderAdapter extends FormlyAttachmentDownloader {
  private attachments = inject(AttachmentHelperService);

  downloadAttachment(id: number | string): void {
    this.attachments.downloadAttachment(Number(id));
  }
}
